import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfileModuleRoutingModule } from './profile-module-routing.module';
import { ProfileComponent } from './profile/profile.component';
import { ProfileupdateComponent } from './profileupdate/profileupdate.component';
import { CustomerdialogComponent } from './customerdialog/customerdialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TermsConditionComponent } from './terms-condition/terms-condition.component';
import { TermsConditionLegalDialogComponent } from './terms-condition-legal-dialog/terms-condition-legal-dialog.component';
import { PaymentTermsDialogComponent } from './payment-terms-dialog/payment-terms-dialog.component';
import { ToastrModule } from 'ngx-toastr';
import { CancelledChequeDialogComponent } from './cancelled-cheque-dialog/cancelled-cheque-dialog.component';
import { InterestUpdateDialogComponent } from './interest-update-dialog/interest-update-dialog.component';
import { IndustryUpdateDialogComponent } from './industry-update-dialog/industry-update-dialog.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { NdaUploadComponent } from './nda-upload/nda-upload.component';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { HighchartsChartModule } from 'highcharts-angular';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { LucideAngularModule, icons } from 'lucide-angular';
import { ElementsModule } from 'src/app/shared/elements/elements.module';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';


@NgModule({
  declarations: [
    ProfileComponent,
    ProfileupdateComponent,
    CustomerdialogComponent,
    TermsConditionComponent,
    TermsConditionLegalDialogComponent,
    PaymentTermsDialogComponent,
    CancelledChequeDialogComponent,
    InterestUpdateDialogComponent,
    IndustryUpdateDialogComponent,
    LandingPageComponent,
    NdaUploadComponent,
  ],
  imports: [
    CommonModule,
    ProfileModuleRoutingModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    ToastrModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    HighchartsChartModule,
    ElementsModule,
    LucideAngularModule.pick(icons),
    NgxIntlTelInputModule,
  ],
})
export class ProfileModuleModule {}
